const forgottenPasswordRules = {
  email: ["required", "trim", "email"],
};

export default forgottenPasswordRules;
